import axios from 'axios';
import { getUser, setUser, User } from 'core/user/user';
import swal from 'sweetalert';

export function initInterceptors() {
  // Interceptor
  axios.interceptors.request.use(
    (config) => {
      const user = getUser() || {};
      config.headers.authorization = user.token;
      const agentToken = sessionStorage.getItem('agent') as any;
      const agentObject = JSON.parse(agentToken);

      if (agentObject) {
        config.headers.agent = agentObject.id;
      }
      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (config) => {
      if (config?.headers?.authorization) {
        let token = config.headers.authorization;
        const matchToken: any = token.split('.');
        let permits = matchToken[1];
        let encodedStringBtoA = atob(permits);
        let parseJson = JSON.parse(encodedStringBtoA);
        let authData = parseJson.auth;
        const permitsList = authData.split(',');
        sessionStorage.setItem('permits', permitsList);
        const model_user: User = {
          sub: parseJson.sub,
          perms: permitsList,
          id: parseJson.id,
          type: parseJson.type,
          token: token,
          role: parseJson.role,
        };
        setUser(model_user);
      }
      if (config?.data) {
        return config.data;
      } else {
        return config;
      }
    },

    (error) => {
      if (error?.response?.status === 401) {
        sessionStorage.removeItem('permits');
        sessionStorage.removeItem('user');
        swal({
          title: 'Sesión caducada',
          text: 'La sesión ha caducado, por favor cierre la ventana e inicie sesión nuevamente',
          icon: 'error',
          buttons: {
            confirm: { text: 'Cerrar' },
          },
        }).then(() => {
          window.location.href = '/login';
        });
      } else if (error?.response?.status === 403) {
        const pathname = window.location.pathname;
        if (pathname !== '/login') {
          swal(
            'Ups...',
            'Ha ocurrido un error, por favor inténtelo de nuevo más tarde',
            'error'
          );
        }
      }
      return Promise.reject(error);
    }
  );
}
